var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-sharing-container position-fixed bg-white d-flex flex-column border",class:{'is--visible': _vm.showSocialSharing}},_vm._l((_vm.shareIcons),function(ref,index){
var network = ref.network;
var icon = ref.icon;
var text = ref.text;
var title = ref.title;
var description = ref.description;
return _c('share-network',{key:text,class:index === 1 ? ['border-bottom', 'border-top'] : '',attrs:{"network":network,"title":title,"url":_vm.fullSiteURL,"description":description}},[_c('font-awesome-icon',{staticClass:"d-inline mx-3 my-3 pl-1",class:{'my-3': index === 1},attrs:{"icon":icon,"size":"lg"}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }